exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-data-bank-datasets-___datasets__datasets___3y_1d {\n  display: flex;\n  justify-content: center;\n  width: 95%;\n  margin: 0 auto;\n}\n\n.src-components-data-bank-datasets-___datasets__datasetCards___3dh8f {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.src-components-data-bank-datasets-___datasets__scrollTopBtn___2Eb7_ {\n  width: 48px;\n  height: 48px;\n  position: fixed;\n  bottom: -60px;\n  right: 20px;\n}\n\n.src-components-data-bank-datasets-___datasets__scrollTopBtn___2Eb7_ > i {\n  color: grey;\n  line-height: 48px;\n}\n\n@media only screen and (max-width: 450px) {\n  .src-components-data-bank-datasets-___datasets__scrollTopBtn___2Eb7_ {\n    bottom: -70px;\n    right: 10px;\n  }\n}", ""]);

// exports
exports.locals = {
	"datasets": "src-components-data-bank-datasets-___datasets__datasets___3y_1d",
	"datasetCards": "src-components-data-bank-datasets-___datasets__datasetCards___3dh8f",
	"scrollTopBtn": "src-components-data-bank-datasets-___datasets__scrollTopBtn___2Eb7_"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/resolve-url-loader!./~/sass-loader!./src/components/data-bank/datasets/datasets.scss
// module id = 1833
// module chunks = 0